export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/contactIconOrange.c40b237c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};